import { PageTabs, PageTabsContent, PageTabsList, PageTabsTrigger } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { PageTabsHeader } from "../../../components";
import { TeamMembersTable } from "./TeamMembersTable";
import { RolesSubPage } from "./RolesSubPage/RolesSubPage";
import { useTeamDefaultViewShallowStore } from "../../../store";
import { useAuth } from "@tellescope/tanstack-query";

export interface TeamSettingsPageProps {
  selectedTab: "team" | "roles" | "configuration";
}

export const TeamSettingsPage = ({ selectedTab }: TeamSettingsPageProps) => {
  const { t } = useTranslation("settings");
  const { selectedOrganization } = useAuth();
  const { lastSelectedViewId } = useTeamDefaultViewShallowStore("lastSelectedViewId");

  return (
    <PageTabs defaultValue={selectedTab} value={selectedTab} className="flex flex-col flex-1 min-h-0 overflow-hidden">
      <PageTabsHeader>
        <PageTabsList>
          <PageTabsTrigger asChild value="team">
            <Link to={`/settings/team/views/${lastSelectedViewId || "all"}`}>{t("Team")}</Link>
          </PageTabsTrigger>
          {selectedOrganization?.plan?.type !== "Healthie-Text" && (
            <PageTabsTrigger asChild value="roles">
              <Link to="/settings/team/roles">{t("Roles")}</Link>
            </PageTabsTrigger>
          )}
        </PageTabsList>
      </PageTabsHeader>
      <PageTabsContent value="team" className="data-[state=active]:flex flex-col flex-1 min-h-0 overflow-hidden">
        <section className="border-b px-6 py-4 space-y-2">
          <h1 className="text-3xl leading-9 text-gray-950 font-semibold">{t("Team")}</h1>
          <h4 className="text-muted-foreground">{t("Manage your team members")}</h4>
        </section>
        <TeamMembersTable />
      </PageTabsContent>
      {selectedOrganization?.plan?.type !== "Healthie-Text" && (
        <PageTabsContent value="roles" className="data-[state=active]:flex flex-col flex-1 min-h-0 overflow-hidden">
          <section className="border-b px-6 py-4 space-y-2">
            <h1 className="text-3xl leading-9 text-gray-950 font-semibold">{t("Roles")}</h1>
            <h4 className="text-muted-foreground">{t("Manage user roles and permissions")}</h4>
          </section>
          <RolesSubPage />
        </PageTabsContent>
      )}
    </PageTabs>
  );
};
